module.exports = __webpack_public_path__ + "static/img/8.194f3d0e.png";